import { Component, Input, OnInit } from '@angular/core';
import { SalesManagementCounts } from 'src/app/core/interfaces/status-counts/sales-management-counts';
import { ApiService } from 'src/app/core/services/api/api.service';
import { LocalStorageService } from 'src/app/core/services/local-storage/local-storage.service';

@Component({
  selector: 'app-sales-management-counts',
  templateUrl: './sales-management-counts.component.html',
  styleUrls: ['./sales-management-counts.component.scss'],
})
export class SalesManagementCountsComponent implements OnInit {
  @Input() salesManagementCounts: SalesManagementCounts;

  allowCommissionViewing: boolean = false;

  constructor(private api: ApiService, private local: LocalStorageService) {}

  ngOnInit(): void {
    this.checkIfUserCanViewCommissions();
  }

  checkIfUserCanViewCommissions(): void {
    let userId = this.local.get('uid');

    if (userId !== null) {
      this.api
        .checkIfUserCanViewCommissions(userId)
        .subscribe((canView) => {
          console.log('Can view commissions:', canView);
          if (canView) {
            this.allowCommissionViewing = true;
          } else {
            this.allowCommissionViewing = false;
          }
        });
    } else {
      this.allowCommissionViewing = false;
    }
  }
}
